import { ExternalLinkIcon } from "lucide-react";
import TechBadge from "../experience/TechIcons";

interface Props {
  project: {
    name: string;
    desc: string;
    tech: string[];
    link: string;
    image: string;
  };
}
const ProjectCard = ({ project }: Props) => {
  return (
    <div className="group rounded-md border border-[#8A8F98]/30 overflow-hidden shadow-md bg-transparent h-auto md:h-[400px] flex flex-col">
      <div className="w-full h-36 overflow-hidden rounded-t-md">
        <img
          src={project.image}
          alt={project.name}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
      </div>

      <div className="p-3 flex flex-col flex-1 justify-between">
        <div>
          <h3 className="text-md font-semibold text-white">{project.name}</h3>
          <p className="mt-1 text-[12px] font-light text-[#A0A3B1]">
            {project.desc}
          </p>
          <div className="mt-3 flex flex-wrap gap-2">
            {project.tech.map((tech, idx) => (
              <TechBadge key={tech} name={tech} idx={idx} />
            ))}
          </div>
        </div>
        <div>
          <div className="border-t border-[#8A8F98]/30 mt-6 lg:mt-0" />
          <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center justify-center gap-2 w-full bg-transparent border hover:bg-[#8A8F98]/30 border-[#8A8F98]/30 text-white px-3 py-2 rounded-md text-xs transition-all duration-200"
          >
            Live <ExternalLinkIcon className="w-3 h-3" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
